import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_selectedApi2skzkr2pn0lot as get_selectedApi } from '../../../sdk/apiOptions.mjs';
import { FinishProoflhqad7xhem5u as FinishProof } from '../../../../../../lightning-server-shared/com/lightningkite/lightningserver/auth/proof/proofModels.mjs';
import { delayolwo40i9ucjz as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { set_value1vvx5pkb20ebv as set_value } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Emitter3oauzcbmv9irf as Emitter } from '../../../../../../reactive/com/lightningkite/reactive/core/processes.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  Char__rangeTo_impl_tkncvp2wb70up86k2i2 as Char__rangeTo_impl_tkncvp,
  Char19o2r8palgjof as Char,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  toList3jhuyej2anx2q as toList,
  minus2znw4oicpx34e as minus,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { validateni5d50psvu9d as validate } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { mutableRemember1h6fyyolumj0o as mutableRemember } from '../../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  Companion_getInstance2v0f9t0g75gcs as Companion_getInstance_0,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { RestartableProcess1yhsc2b2m6aws as RestartableProcess } from '../../../utils/RestartableProcess.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_pageNavigator1inl9j7ja0vlf as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import {
  xlTitle2v7mu4p1j9wv3 as xlTitle,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  smallBody2trfy14zwtona as smallBody,
} from '../../theming/Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import {
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { errorTextv58wi1t0me7u as errorText } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$Action, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_issues($this.gip_1.aip_1);
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!tmp.i1())
    return Unit_instance;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_selectedApi();
  var tmp_0 = await_1(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var api = tmp_0.dfx();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.hip_1;
  var tmp_1 = await_0(this_2, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = tmp_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.gip_1.aip_1;
  var tmp_3 = await_1(this_3, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp$ret$4 = tmp_3;
  var tmp_4 = api.uff_1.iei(new (FinishProof())(tmp_2, tmp$ret$4), $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var proof = tmp_4;
  var tmp_5 = $this.gip_1.yio_1(proof, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$RestartableProcess, $completion) {
  var count = 10;
  while (count > 0) {
    var _unary__edvuaz = count;
    count = _unary__edvuaz - 1 | 0;
    $this$RestartableProcess.gaq(_unary__edvuaz);
    if (count < 7) {
      $this.iip_1.eip_1.oam(false);
    }
    var tmp = delay(1000n, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  $this$RestartableProcess.gaq(null);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = $this.jip_1.vio_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  set_value($this.jip_1.cip_1, tmp);
  $this.jip_1.eip_1.oam(true);
  $this.jip_1.fip_1.zg5();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = $this.kip_1.xio_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var EmailProof$login$slambdaClass;
function EmailProof$login$slambda() {
  if (EmailProof$login$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $token) {
        this.gip_1 = this$0;
        this.hip_1 = $token;
      }
      yah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EmailProof$login$slambdaClass = $;
  }
  return EmailProof$login$slambdaClass;
}
function EmailProof$login$slambda_0(this$0, $token) {
  var i = new (EmailProof$login$slambda())(this$0, $token);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
var EmailProof$cooldown$slambdaClass;
function EmailProof$cooldown$slambda() {
  if (EmailProof$cooldown$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.iip_1 = this$0;
      }
      lip($this$RestartableProcess, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$RestartableProcess), $completion);
      }
      s2(p1, $completion) {
        return this.lip((!(p1 == null) ? isInterface(p1, Emitter()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EmailProof$cooldown$slambdaClass = $;
  }
  return EmailProof$cooldown$slambdaClass;
}
function EmailProof$cooldown$slambda_0(this$0) {
  var i = new (EmailProof$cooldown$slambda())(this$0);
  var l = ($this$RestartableProcess, $completion) => i.lip($this$RestartableProcess, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var EmailProof$render$slambdaClass;
function EmailProof$render$slambda() {
  if (EmailProof$render$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.jip_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EmailProof$render$slambdaClass = $;
  }
  return EmailProof$render$slambdaClass;
}
function EmailProof$render$slambda_0(this$0) {
  var i = new (EmailProof$render$slambda())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var EmailProof$render$slambdaClass_0;
function EmailProof$render$slambda_1() {
  if (EmailProof$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.kip_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EmailProof$render$slambdaClass_0 = $;
  }
  return EmailProof$render$slambdaClass_0;
}
function EmailProof$render$slambda_2(this$0) {
  var i = new (EmailProof$render$slambda_1())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var EmailProofClass;
function EmailProof() {
  if (EmailProofClass === VOID) {
    class $ {
      static mip(token, resend, email, onDifferentEmail, withProof) {
        var $this = createThis(this);
        $this.vio_1 = resend;
        $this.wio_1 = email;
        $this.xio_1 = onDifferentEmail;
        $this.yio_1 = withProof;
        $this.zio_1 = minus(toList(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90))), setOf([new (Char())(_Char___init__impl__6a9atx(73)), new (Char())(_Char___init__impl__6a9atx(79))]));
        var tmp = $this;
        var tmp_0 = Signal().hak('');
        tmp.aip_1 = validate(tmp_0, VOID, (str) => {
          var tmp;
          if (!(str.length === 6)) {
            tmp = 'Passcode must have 6 digits';
          } else {
            var tmp$ret$1;
            $l$block: {
              // Inline function 'kotlin.text.any' call
              var inductionVariable = 0;
              while (inductionVariable < charSequenceLength(str)) {
                var element = charSequenceGet(str, inductionVariable);
                inductionVariable = inductionVariable + 1 | 0;
                if (!$this.zio_1.t1(new (Char())(element))) {
                  tmp$ret$1 = true;
                  break $l$block;
                }
              }
              tmp$ret$1 = false;
            }
            if (tmp$ret$1) {
              tmp = 'Passcode can only contain these characters: ' + joinToString($this.zio_1);
            } else {
              tmp = null;
            }
          }
          return tmp;
        });
        var tmp_1 = $this;
        tmp_1.cip_1 = mutableRemember(VOID, VOID, ($this$mutableRemember) => $this$mutableRemember.daj(token));
        var tmp_2 = $this;
        var tmp_3 = Companion_getInstance().ecg_1;
        tmp_2.dip_1 = Action('Log In', tmp_3, VOID, VOID, VOID, VOID, EmailProof$login$slambda_0($this, token));
        $this.eip_1 = Signal().hak(false);
        var tmp_4 = $this;
        tmp_4.fip_1 = RestartableProcess().yg5(VOID, EmailProof$cooldown$slambda_0($this));
        return $this;
      }
      static nip(token, resend, email, onDifferentEmail, withProof) {
        return this.mip(new (Constant())(_Constant___init__impl__v45mub(token)), resend, email, onDifferentEmail, withProof);
      }
      wd6(_this__u8e3s4) {
        var tmp = sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, get_rem(30));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        this.bip_1 = get_pageNavigator(view);
        xlTitle(view, 'Confirm Email');
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (TextView())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.lba(view_0.qb6_1.abf(BodySemantic_getInstance()));
        var tmp_0 = KMutableProperty0();
        var tmp_1 = TextView$_get_content_$ref_4pzcwl(view_0);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(view_0));
        reactiveScope(view_0, ($this$reactiveScope) => {
          // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
          var tmp$ret$1 = 'An email was just sent to ' + this.wio_1($this$reactiveScope) + '. Enter the passcode below to confirm your email and finish registering.';
          this_0.set(tmp$ret$1);
          return Unit_instance;
        });
        view.hbb(p_0, view_0);
        // Inline function 'com.crowpay.views.components.field2' call
        var label = 'Passcode';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_1 = view.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.gbb(p_1, view_1);
        view_1.zbm(true);
        view_1.bb9(get_AppDimensions().pg2_1);
        bodyBold(view_1, label);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_2 = view_1.jbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (TextInput())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value = 'Passcode';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_2.vb5_1.bb4_1.kb7_1.placeholder = value;
        view_2.cbs(Companion_getInstance_0().td5_1);
        view_2.zah(view_2.icn_1, this.aip_1);
        view_2.obg(this.dip_1);
        view_1.hbb(p_2, view_2);
        view_1.lbb(tmp_2, view_2);
        view_1.lbb(view_1.jbb(SubtextSemantic_getInstance()), errorText(view_1));
        view.hbb(p_1, view_1);
        var tmp_3 = get_primaryButton(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Button())(view.pc());
        var tmp0_elvis_lhs_3 = view.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
        view.gbb(p_3, view_3);
        var tmp_4 = KMutableProperty0();
        var tmp_5 = Button$_get_enabled_$ref_61t7nx(view_3);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('enabled', 0, tmp_4, tmp_5, Button$_set_enabled_$ref_o8kynz(view_3));
        reactiveScope(view_3, ($this$reactiveScope) => {
          var tmp$ret$20 = $this$reactiveScope.daj(get_issues(this.aip_1)).i1();
          this_1.set(tmp$ret$20);
          return Unit_instance;
        });
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextView())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.gbb(p_4, view_4);
        view_4.lba(view_4.qb6_1.abf(BodySemantic_getInstance()));
        view_4.dbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_6 = view_4.vb5_1;
        var tmp_7;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength('Submit') === 0) {
          tmp_7 = '\xA0';
        } else {
          tmp_7 = 'Submit';
        }
        tmp_6.hbu(tmp_7);
        view_3.hbb(p_4, view_4);
        view_3.obg(this.dip_1);
        view.hbb(p_3, view_3);
        view.lbb(tmp_3, view_3);
        var tmp_8 = get_centered(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_5 = view.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
        view.gbb(p_5, view_5);
        view_5.zbm(true);
        var tmp_9 = view_5.kbb(get_centered(view_5), get_textButton(view_5));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Button())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.gbb(p_6, view_6);
        var tmp_10 = KMutableProperty0();
        var tmp_11 = Button$_get_enabled_$ref_61t7nx_0(view_6);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_2 = getPropertyCallableRef('enabled', 0, tmp_10, tmp_11, Button$_set_enabled_$ref_o8kynz_0(view_6));
        reactiveScope(view_6, ($this$reactiveScope) => {
          var tmp$ret$32 = $this$reactiveScope.daj(this.fip_1) == null;
          this_2.set(tmp$ret$32);
          return Unit_instance;
        });
        // Inline function 'com.crowpay.views.theming.smallBody' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (TextView())(view_6.pc());
        var tmp0_elvis_lhs_7 = view_6.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
        view_6.gbb(p_7, view_7);
        view_7.lba(view_7.qb6_1.abf(SmallBodySemantic_getInstance()));
        var tmp_12 = KMutableProperty0();
        var tmp_13 = TextView$_get_content_$ref_4pzcwl_0(view_7);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_3 = getPropertyCallableRef('content', 0, tmp_12, tmp_13, TextView$_set_content_$ref_pketfb_0(view_7));
        reactiveScope(view_7, ($this$reactiveScope) => {
          var tmp;
          if ($this$reactiveScope.daj(this.eip_1)) {
            tmp = 'Email sent!';
          } else {
            var tmp0_safe_receiver = $this$reactiveScope.daj(this.fip_1);
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp_0 = 'Can resend code in ' + tmp0_safe_receiver;
            }
            var tmp1_elvis_lhs = tmp_0;
            tmp = tmp1_elvis_lhs == null ? 'Send me a new code' : tmp1_elvis_lhs;
          }
          var tmp$ret$36 = tmp;
          this_3.set(tmp$ret$36);
          return Unit_instance;
        });
        view_6.hbb(p_7, view_7);
        onClick(view_6, 'Send Code', VOID, EmailProof$render$slambda_0(this));
        view_5.hbb(p_6, view_6);
        view_5.lbb(tmp_9, view_6);
        var tmp_14 = view_5.kbb(get_centered(view_5), get_textButton(view_5));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (Button())(view_5.pc());
        var tmp0_elvis_lhs_8 = view_5.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_5 : tmp0_elvis_lhs_8;
        view_5.gbb(p_8, view_8);
        smallBody(view_8, 'Use a different email');
        onClick(view_8, 'Use different email', VOID, EmailProof$render$slambda_2(this));
        view_5.hbb(p_8, view_8);
        view_5.lbb(tmp_14, view_8);
        view.hbb(p_5, view_5);
        view.lbb(tmp_8, view_5);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'EmailProof', VOID, VOID, [Page()]);
    EmailProofClass = $;
  }
  return EmailProofClass;
}
//region block: exports
export {
  EmailProof as EmailProof3rgt8vdvz5buo,
};
//endregion

//# sourceMappingURL=EmailProof.mjs.map
